import { Pressable } from "@/components/ui/pressable";
import { Text } from "@/components/ui/text";
import { HStack } from "@/components/ui/hstack";
import React from 'react';
import { IconM } from '../media/IconsV2';

export default function PressableElement({ header, mainText, secondaryText, fontSize, pressed, px, color }) {
    return (
        <>
            {header && <Text className="text-2xl mb-2 mt-1 leading-2xl text-secondary-900">{header}</Text>}
            <Pressable onPress={() => pressed()} className={` ${px ? px : "px-3"} w-[100%] mb-3 `}>
                <HStack className="justify-between">
                    <Text className={` ${color ? color : "text-secondary-900"} ${fontSize ? fontSize : "text-xl"} font-[400] leading-2xl `}>
                        {mainText}
                    </Text>
                    <HStack space='lg'>
                        <Text className={` ${color ? color : "text-secondary-900"} ${fontSize ? fontSize : "text-xl"} font-[400] leading-2xl `}>
                            {secondaryText}
                        </Text>
                        <IconM className={`text-primary-900 text-3xl`} name='keyboard-arrow-right' />
                    </HStack>
                </HStack>
            </Pressable>
        </>
    );
}